import { render } from "./message.vue?vue&type=template&id=0559660d"
import script from "./message.js?vue&type=script&lang=js&external"
export * from "./message.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__